import { render, staticRenderFns } from "./UsersShow.vue?vue&type=template&id=3d72c9bf&scoped=true&"
import script from "./UsersShow.vue?vue&type=script&lang=js&"
export * from "./UsersShow.vue?vue&type=script&lang=js&"
import style0 from "../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d72c9bf",
  null
  
)

export default component.exports